import splash from './top/splash'

import contentSec from './top/contentSec'
import newsSec from './top/newsSec';
import infoSec from './top/infoSec'
import accessSec from './top/accessSec';

(() => {
  splash()
  contentSec();
  newsSec();
  infoSec();
  accessSec();
})()
